import { Query } from '@repo/graphql/graphql'
import { differenceInDays } from 'date-fns'
import { useState } from 'react'
import PortalContainer from '../../../../components/container/PortalContainer'
import AchievementCard from '../../../../components/new-portal/achievement/AchievementCard'
import AchievementsTopBar from '../../../../components/new-portal/achievement/AchievementsTopBar'
import LevelUpCallout from '../../../../components/new-portal/achievement/LevelUpCallout'
import { useLevelUpInfo } from '../../../../modules/apis/achievement/queries'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { n_achievement } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

interface IVariables {
  isVisible: boolean[]
}

export const AchievementsBody = () => {
  const { t } = useTranslation()
  const isWebview = useIsWebview()

  const [showCallout, setShowCallout] = useState(false)
  const [totalCount, setTotalCount] = useState(null)

  const { data } = useLevelUpInfo(
    {
      first: 10,
      last: 2,
    },
    {
      onSuccess: (data: Query) => {
        let levelUpCampaignCount = 0

        data?.achievementCampaigns.edges.some((edge) => {
          const campaign = edge.node
          const myAchievementStage = campaign.myAchievementStages?.nodes[0]

          const daysGap = differenceInDays(new Date(), new Date(myAchievementStage?.completedAt))

          if (daysGap >= 0 && daysGap <= 7) {
            levelUpCampaignCount++
            setTotalCount(levelUpCampaignCount)
          }
        })

        if (levelUpCampaignCount > 0) setShowCallout(true)
      },
    }
  )

  return (
    <div className="sm:pb-120 flex flex-col bg-gray-50 px-16 py-20 pb-64 sm:mx-32 sm:bg-white sm:px-0 sm:pt-40 lg:max-w-[688px] xl:mx-0">
      {!isWebview && <div className="Hero4-32Bd mb-20 mt-4 sm:mt-0">{t(n_achievement.title)}</div>}
      <div className="Body1-16Md mb-16 text-gray-700 sm:mb-20">{t(n_achievement.info)}</div>
      {showCallout && <LevelUpCallout totalCount={totalCount} />}
      <div className="flex flex-col gap-12 sm:gap-16">
        <AchievementCard />
      </div>
    </div>
  )
}

const AchievementsPage = () => {
  return (
    <PortalContainer
      layoutClassName="mx-auto w-full max-w-[1040px] mt-[60px] sm:mt-[59px]"
      noDefaultBar
      eventName="achievements"
      topBar={<AchievementsTopBar />}
    >
      <AchievementsBody />
    </PortalContainer>
  )
}

export default AchievementsPage
